import { ErrorPlaceholder } from "lib-core"

export { ErrorPlaceholder }
export default ErrorPlaceholder
